import axios from 'axios'

export default {
    namespaced: true,
    state: {
        emaApplication: {},
    },
    mutations: {
        SET_EMA_APPLICATION(state, payload) {
            state.emaApplication = payload;
        },
    },
    actions: {
        async FetchEMAApplication({ commit }, obj) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/applications/ema/fetch`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) {
                            response.data.payload = HydratePayload(response.data.payload);

                            commit('SET_EMA_APPLICATION', response.data.payload);
                            resolve(response.data.message);
                        } else reject(response.data.message);
                    }).catch(error => reject(`FetchEMAApplication: ${error.message}`));
            });
        },
        async FetchEMAApplicationByCourseCode({ }, obj) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/applications/ema/fetch/course-code`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) {
                            response.data.payload = HydratePayload(response.data.payload);

                            resolve(response.data.payload);
                        } else reject(response.data.message);
                    }).catch(error => reject(`FetchEMAApplication: ${error.message}`));
            });
        },
        async InsertEMAApplication({ }, obj) {
            obj.Payload = DehydratePayload(obj.Payload);

            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/applications/ema/insert`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) resolve(response.data);
                        else reject(response.data.message);
                    }).catch(error => reject(`InsertEMAApplication: ${error.message}`));
            });
        },
        async UpdateEMAApplication({ }, obj) {
            obj.Payload = DehydratePayload(obj.Payload);

            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/applications/ema/update`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) resolve(response.data);
                        else reject(response.data.message);
                    }).catch(error => reject(`UpdateEMAApplication: ${error.message}`));
            });
        },
        async UpdateEMAApplicationBypassEvidenceFields({ }, obj) {
            obj.BypassEvidenceFields = StringifyJSON(obj.BypassEvidenceFields);

            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/applications/ema/update/bypass-evidence-fields`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) resolve(response.data);
                        else reject(response.data.message);
                    }).catch(error => reject(`UpdateEMAApplicationBypassEvidenceFields: ${error.message}`));
            });
        },
        async UpdateEMAApplicationLastPageAccessed({ }, obj) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/applications/ema/update/last-page-accessed`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) resolve(response.data);
                        //else reject(response.data.message);
                    }).catch(error => reject(`UpdateEMAApplicationLastPageAccessed: ${error.message}`));
            });
        },
        async SubmitEMAApplication({ }, obj) {
            obj.Payload = DehydratePayload(obj.Payload);

            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/applications/ema/submit`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) resolve(response.data);
                        else reject(response.data.message);
                    }).catch(error => reject(`SubmitEMAApplication: ${error.message}`));
            });
        },
        async CancelEMAApplication({ }, obj) {
            obj.Payload = DehydratePayload(obj.Payload);

            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/applications/ema/cancel`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) resolve(response.data);
                        else reject(response.data.message);
                    }).catch(error => reject(`CancelEMAApplication: ${error.message}`));
            });
        },
        async DeleteEMAApplication({ }, obj) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/applications/ema/delete`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) resolve(response.data);
                        else reject(response.data.message);
                    }).catch(error => reject(`DeleteEMAApplication: ${error.message}`));
            });
        },
    },
    getters: {
        EMAApplication(state) { return state.emaApplication; },
    }
};

function HydratePayload(payload) {
    if (payload != null) {
        payload.benefitsReceived = CoalesceJSON(payload.benefitsReceived);
        payload.previousAddresses = CoalesceJSON(payload.previousAddresses);
        payload.otherOccupants = CoalesceJSON(payload.otherOccupants);
        payload.childrenDetails = CoalesceJSON(payload.childrenDetails);
        payload.careExperienceTypes = CoalesceJSON(payload.careExperienceTypes);
        payload.studentHistory = CoalesceJSON(payload.studentHistory);
        payload.parentDependentChildrenDetails = CoalesceJSON(payload.parentDependentChildrenDetails);
        payload.parent1EmploymentHistoryDetails = CoalesceJSON(payload.parent1EmploymentHistoryDetails);
        payload.parent2EmploymentHistoryDetails = CoalesceJSON(payload.parent2EmploymentHistoryDetails);
        payload.partnerEmploymentHistoryDetails = CoalesceJSON(payload.partnerEmploymentHistoryDetails);
        payload.discussApplicationPeople = CoalesceJSON(payload.discussApplicationPeople);
        payload.overrideEvidenceFields = CoalesceJSON(payload.overrideEvidenceFields);
        payload.requiredEvidenceFields = CoalesceJSON(payload.requiredEvidenceFields);
        payload.bypassEvidenceFields = CoalesceJSON(payload.bypassEvidenceFields);
    }

    return payload;
}
function DehydratePayload(payload) {
    if (payload != null) {
        payload.benefitsReceived = StringifyJSON(payload.benefitsReceived);
        payload.previousAddresses = StringifyJSON(payload.previousAddresses);
        payload.otherOccupants = StringifyJSON(payload.otherOccupants);
        payload.childrenDetails = StringifyJSON(payload.childrenDetails);
        payload.careExperienceTypes = StringifyJSON(payload.careExperienceTypes);
        payload.studentHistory = StringifyJSON(payload.studentHistory);
        payload.parentDependentChildrenDetails = StringifyJSON(payload.parentDependentChildrenDetails);
        payload.parent1EmploymentHistoryDetails = StringifyJSON(payload.parent1EmploymentHistoryDetails);
        payload.parent2EmploymentHistoryDetails = StringifyJSON(payload.parent2EmploymentHistoryDetails);
        payload.partnerEmploymentHistoryDetails = StringifyJSON(payload.partnerEmploymentHistoryDetails);
        payload.discussApplicationPeople = StringifyJSON(payload.discussApplicationPeople);
        payload.overrideEvidenceFields = StringifyJSON(payload.overrideEvidenceFields);
        payload.requiredEvidenceFields = StringifyJSON(payload.requiredEvidenceFields);
        payload.bypassEvidenceFields = StringifyJSON(payload.bypassEvidenceFields);
    }

    return payload;
}
function StringifyJSON(object) {
    if (object == null) return null;
    else if (typeof object == 'string') return object;
    else return JSON.stringify(object);
};
function CoalesceJSON(object, returnObject) {
    if (object == null || object == '') return returnObject;
    else if (typeof object == 'object') return object;
    else return JSON.parse(object);
};

